import { api } from '../../shared/api/client';
import { adaptUser } from '../../shared/api/adapters';
import type { ApiUser } from '../../shared/types/api';

export async function fetchMe() {
  const res = await api.get<ApiUser>('/api/v1/users/me');
  return adaptUser(res);
}

export async function updateMe(updates: Partial<{ name: string; phone: string; company: string; avatarUrl: string | null }>) {
  const res = await api.patch<ApiUser>('/api/v1/users/me', updates);
  return adaptUser(res);
}

export async function updateNotificationPrefs(jobUpdates: boolean) {
  const res = await api.patch<ApiUser>('/api/v1/users/me/notification-prefs', { jobUpdates });
  return adaptUser(res);
}

export async function completeOnboarding() {
  const res = await api.patch<ApiUser>('/api/v1/users/me/onboarding', { onboardingCompleted: true });
  return adaptUser(res);
}

export async function recordConsent(privacyPolicyVersion: string) {
  const res = await api.patch<ApiUser>('/api/v1/users/me/consent', { privacyPolicyVersion });
  return adaptUser(res);
}

export async function syncEmailFromClerk() {
  const res = await api.patch<ApiUser>('/api/v1/users/me/sync-email');
  return adaptUser(res);
}

export async function deleteMe() {
  return api.delete<{ message: string }>('/api/v1/users/me');
}
